/**
 * Canonical order received timestamp — Customer + Manager share the same source.
 * Prefer server created_at / placed_at; never invent client clock.
 */
export function getOrderReceivedAt(order: {
  created_at?: string | null;
  placed_at?: string | null;
  received_at?: string | null;
  [key: string]: unknown;
}): string | null {
  const candidates = [order.placed_at, order.received_at, order.created_at];
  for (const c of candidates) {
    const s = String(c ?? "").trim();
    if (s && !Number.isNaN(Date.parse(s))) return s;
  }
  return null;
}

const TZ = "Europe/Kyiv";

function kyivClock(raw: string): string | null {
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleTimeString("uk-UA", {
    timeZone: TZ,
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}

/** Compact card time: today = HH:MM; else DD.MM · HH:MM (Kyiv). */
export function formatOrderReceivedCardTime(
  raw: string | null | undefined,
  now = new Date(),
): string {
  if (!raw) return "";
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return "";
  const clock = kyivClock(raw);
  if (!clock) return "";
  const dayFmt = new Intl.DateTimeFormat("en-CA", {
    timeZone: TZ,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  if (dayFmt.format(d) === dayFmt.format(now)) return clock;
  const dm = new Intl.DateTimeFormat("uk-UA", {
    timeZone: TZ,
    day: "2-digit",
    month: "2-digit",
  }).format(d);
  return `${dm} · ${clock}`;
}
